import {SelectField} from '@wandb/components';
import {useSyncedState} from '@wandb/weave/common/util/hooks';
import React, {type FC, useId} from 'react';
import {type Key} from 'react-aria-components';

import {
  type Axis,
  type MediaBrowserPanelConfig,
} from '../../../../PanelMediaBrowser/common';
import {getAxisOptions} from '../../../../PanelMediaBrowser/PanelSettings';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsActions} from '../contexts/MediaSettingsContextProvider';

type AxisDropdownProps = {
  initialValue: Axis;
  onSelectOption: (option: Axis) => void;
  title: string;
  configField: keyof MediaBrowserPanelConfig;
};

export const AxisDropdown: FC<AxisDropdownProps> = ({
  initialValue,
  onSelectOption,
  title,
  configField,
}) => {
  const titleId = useId();
  const {unsetConfigField} = useMediaSettingsActions();
  const axisOptions = getAxisOptions();

  const {state: selectedOption, setState: setSelectedOption} =
    useSyncedState<Axis>({
      stateToSyncWith: initialValue,
      setStateToSyncWith: onSelectOption,
    });
  const onChangeDropdown = (key: Key | null) => {
    if (key != null) {
      setSelectedOption(key as Axis);
    }
  };
  return (
    <div className="flex flex-col" data-test={`${title}-dropdown`}>
      <SettingTitle
        id={titleId}
        title={title}
        configField={configField}
        unsetConfigField={() => unsetConfigField(configField)}
      />
      <SelectField
        aria-label={title}
        items={axisOptions}
        value={selectedOption}
        onChange={onChangeDropdown}
        fullWidth
      />
    </div>
  );
};
